module.exports = __webpack_public_path__ + "img/sparking-change-create.294847b8.png";